<template>
    <modal modal_name="edit_poll" :title="translations['forum.edit_poll']" icon="poll-h" type="large">
        <template v-slot:modal-content>
            <validation-observer ref="modal-edit_poll" v-if="poll_data">
                <form-row>
                    <form-field>
                        <label class="form-label">{{ translations['forum.poll_question'] }}</label>

                        <huddle-editor-v2   v-model="poll.question"
                                            :single_line="true"
                                            :allow_enter_shift="false"
                                            placeholder="Poll question"
                                            rules="required"
                                            name="question">
                        </huddle-editor-v2>
                    </form-field>
                </form-row>

                <label class="form-label">{{ translations['forum.poll_answers'] }}</label>

                <form-row v-for="(answer, index) in poll.question_options" :key="index">
                    <form-field>
                        <div class="flex">
                            <huddle-editor-v2   class="tw-flex-1"
                                                v-model="answer.value"
                                                :single_line="true"
                                                :allow_enter_shift="false"
                                                placeholder="Answer"
                                                rules="required"
                                                :name="'pollanswer' + index"
                                                :key="'pollanswer' + index">
                            </huddle-editor-v2>
                            <div class="tw-flex tw-items-center tw-justify-center tw-px-6 tw--mt-1" v-if="pollAnswersLength === index+1 || pollAnswersLength > 2">
                                <i class="fa fa-trash warning-color hover-opacity" v-if="pollAnswersLength > 2" @click="deleteAnswer(answer, index)"></i>
                                <i class="fa fa-plus tw-text-gray-600 hover-opacity" :class="{'tw-pl-6': pollAnswersLength > 2}" v-if="pollAnswersLength === index+1" @click="addEmptyAnswer"></i>
                            </div>
                        </div>
                    </form-field>
                </form-row>

                <label class="form-label">{{ translations['poll.settings'] }}</label>
                <div class="switch-wrapper" v-if="pollSettings.retry">
                    <div class="switch" :class="{'active': pollSettings.retry === '1'}" @click="switchPollSetting('retry')">
                        <div class="thumb"></div>
                    </div>
                    <p>{{ translations['poll.allow_changing_answer'] }}</p>
                </div>
                <div class="switch-wrapper tw-mt-4" v-if="pollSettings.poll_allow_guest_answers">
                    <div class="switch" :class="{'active': pollSettings.poll_allow_guest_answers === '1'}" @click="switchPollSetting('poll_allow_guest_answers')">
                        <div class="thumb"></div>
                    </div>
                    <p>{{ translations['poll.allow_guest_answers'] }}</p>
                </div>
                <div class="switch-wrapper tw-mt-4" v-if="pollSettings.poll_public">
                    <div class="switch" :class="{'active': pollSettings.poll_public === '1'}" @click="switchPollSetting('poll_public')">
                        <div class="thumb"></div>
                    </div>
                    <p>{{ translations['poll.show_who_voted_what'] }}</p>
                </div>
                <div class="switch-wrapper tw-mt-4" v-if="pollSettings.poll_multiple_answers">
                    <div class="switch" :class="{'active': pollSettings.poll_multiple_answers === '1'}" @click="switchPollSetting('poll_multiple_answers')">
                        <div class="thumb"></div>
                    </div>
                    <p>{{ translations['poll.allow_multiple_answers'] }}</p>
                </div>
                <template v-if="poll_scheduled_date !== ''">
                    <div class="tw-flex tw-mt-4 tw-mb-2 tw-text-gray-400 tw-items-center">
                        <i class="far fa-calendar-alt tw-pr-2"></i>
                        <p>{{ translations['poll.ends_at'] }}: </p>
                    </div>
                </template>
                <template v-else>
                    <div class="tw-flex tw-items-center tw-text-gray-400 hover-opacity tw-mt-4" @click="togglePollScheduler">
                        <i class="far fa-calendar-alt tw-pr-2"></i>
                        <p>{{ translations['poll.add_end_date'] }}</p>
                    </div>
                </template>
                <div class="edit-poll-scheduled-date" :class="{'show': poll_scheduled_date}">
                    <datetime ref="pollDatePicker"
                              v-on:input="setPollDate"
                              :format="{ year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: '2-digit', timeZoneName: 'short' }"
                              v-on:close="togglePollScheduler"
                              type="datetime"
                              v-model="poll_scheduled_date"
                              value-zone="Europe/Amsterdam"
                              auto></datetime>
                </div>
                <div v-if="poll_scheduled_date !== ''" class="tw-flex tw-items-center warning-color tw-mt-3 tw-font-semibold hover-opacity" @click="removeEndDate">
                    <i class="tw-pr-1 far fa-times"></i>
                    <span class="tw-text-sm">Verwijder einddatum</span>
                </div>
            </validation-observer>
        </template>

        <template v-slot:modal-bottom>
            <div class="subtle-button slim" @click="closePopup">
                {{ translations['fields.cancel'] }}
            </div>
            <div class="general-button btn-v2 slim" @click="submitEdit">
                Edit poll
                <i class="far fa-check"></i>
            </div>
        </template>
    </modal>
</template>

<script>
    import { Datetime } from 'vue-datetime';
    import cloneDeep from 'lodash.clonedeep';
    import moment from 'moment';

    import Modal from '../../mixins/v2/Modal.js'
    import Global from '../../mixins/Global.js'

    import { EventBus } from '../../lib/event-bus';

    export default {
        mixins: [Modal, Global],
        name: 'EditPoll',

        components: {
            datetime: Datetime,
        },

        data() {
            return {
                poll_data: false,
                show_must_have_two_answers: false,
                poll_scheduled_date: '',
            }
        },

        computed: {
            pollAnswersLength() {
                return this.poll.question_options.length;
            },

            poll() {
                return this.poll_data.poll;
            },

            pollSettings() {
                return this.poll_data.settings;
            },
        },

        methods: {
            addEmptyAnswer() {
                this.poll.question_options.push({
                    uid: Date.now() + ( (Math.random()*100000).toFixed()),
                    is_correct: false,
                    number_of_responses: 0,
                    question_id: this.popup_data.poll.id,
                    value: '',
                    newly_created: true,
                });
            },

            deleteAnswer(answer, index) {
                if (this.poll.question_options.length <= 2) {
                    this.show_must_have_two_answers = true;
                } else {
                    this.show_must_have_two_answers = false;

                    if (answer.newly_created) {
                        this.poll.question_options.splice(index, 1);
                    } else {
                        this.$store.dispatch('poll/deleteOption', answer)
                            .then(() => {
                                this.poll.question_options.splice(index, 1);
                            });
                    }
                }
            },

            switchPollSetting(setting) {
                if(this.pollSettings[setting] === '1') {
                    this.pollSettings[setting] = '0';
                } else {
                    this.pollSettings[setting] = '1';
                }
            },

            togglePollScheduler() {
                if(!this.poll_scheduled_date) {
                    this.$nextTick(() => {
                        if(this.$refs.pollDatePicker) {
                            this.$refs.pollDatePicker.$el.firstElementChild.click();
                        }
                    });
                }
            },

            setPollDate(date) {
                if(date) {
                    this.poll_scheduled_date = date;
                }
            },

            removeEndDate() {
                this.poll_scheduled_date = '';
            },

            submitEdit() {
                this.validateModal().then(() => {
                    if(this.poll_scheduled_date !== '') {
                        this.poll_data.end_date = this.poll_scheduled_date;
                    }

                    EventBus.$emit(`poll-${this.popup_data.poll_id}-updated`, this.poll_data);
                }).catch(() => {});
            },
        },

        mounted() {
            //clone the data we get so we dont alter the original
            this.poll_data = cloneDeep(this.popup_data);

            //parse the end_date setting with moment and save it in a local variable, because cloneDeep can't seem to clone the original end_date variable
            if(this.poll_data.settings.end_date !== '') {
                this.poll_scheduled_date = moment(this.poll_data.settings.end_date, moment.ISO_8601).format();
                //also remove the end_date setting from the cloned settings list
                delete this.poll_data.settings['end_date'];
            }
        }
    };
</script>

<style lang="scss">
    .edit-poll-scheduled-date {
        position: relative;

        input {
            display: none;
            background: none;
            border: 0;
            padding: 0;
            margin-top: 10px;
            color: #c7c7c7;
            font-size: 13px;

            &:hover {
                cursor: pointer;
            }
        }

        &:hover {
            cursor: pointer;
        }

        &.show {
            &:before {
                display: block;
            }

            input {
                display: block;
            }
        }
    }
</style>